export enum ConsumptionAgainstEnum {
    STYLE = "STYLE",
    ITEM = "ITEM",
    ITEM_AND_SIZE = "ITEMANDSIZE"
}